import { 
    RemoveRedEye as ViewIcon
} from '@mui/icons-material';

import Input from '@/components/Input';
import Button from '/src/components/Button';

import { getFileType, formatBytes } from '@/utils/File';

// files previews when adding, editing, etc.
export default function InputFile({t,files,table,field,editable,data,setData,openUrlModal,config,errors,size}){

    // to manage files
    const handleFileInput = (e) => {

        const name = e.target.name;   
        //const file = e.target.files[0];
        const files = e.target.files;

        if(files && files?.length > 0){

            const newData = {...data};

            if(!Object.hasOwn(newData,name) || !newData[name]){
                newData[name] = [];                
            }

            Array.from(files).forEach((file) => {

                var mime = file?.type;
                var type = getFileType(mime);

                // create temporary url
                var objectUrl = URL.createObjectURL(file);
                
                // add item                    
                var newFile = {
                    type: type,
                    mime: mime,
                    name: file?.name ? file?.name : type && t('types.'+type) !== 'types.'+type ? t('types.'+type) : t('types.file'),
                    path: objectUrl,
                    upload: file
                };
                
                newData[name].push(newFile); 
                               
            });

            setData(newData);
        }
    }

    // to remove files
    const handleRemoveFile = (e,field,index,restore = false) => {

        if(data[field][index] !== undefined && data[field][index] !== null){

            var newData = {...data};

            var deleteItem = 1;
            if(restore){
                deleteItem = 0;
            }

            newData[field][index].delete = deleteItem;            

            setData(newData);            
        }
    }

    return (
        <>
        <Input
            name='files'
            type='file'                                        
            value={data.files}
            placeholder={
                !config?.simple && config?.max && config.max > 1 ? 
                    t('resource_rentals.maintenance.fields.files')+' (max: '+config.max+')'
                : 
                    t('resource_rentals.maintenance.fields.files')
            }                          
            shrink                                                    
            onChange={handleFileInput}
            error={errors && errors?.files ? t('resource_rentals.maintenance.errors.'+errors.files) : ''}
            accept={config?.accept && config.accept?.length > 0 ? config.accept : null}
            multiple={config?.simple ? false : !config?.max || (config?.max && config.max > 1) ? true : false}
        />
        <div className={'item-modal-link-files'}>
            {
                files && files?.length > 0 && files?.map((item,index) => {

                    var linkText = item?.name ? item.name : item?.type && t('types.'+item.type) !== 'types.'+item.type ? t('types.'+item.type) : t('types.file');                                                                
                    
                    return (                                                                        
                        <div 
                            key={'table_'+table+'_item_'+item?.rowIndex+'_field_'+field+'_files_'+index}
                            className={`
                                ${
                                    item.type === 'image' ? 
                                        'item-modal-link-file-preview-div'+(size ? '-'+size : '')
                                    : 
                                        'item-modal-link-file-div'+(size ? '-'+size : '')
                                } 
                                ${
                                    item?.upload && errors && Object.hasOwn(errors,field)? 
                                        'border-red-500' 
                                    : 
                                        ''
                                }
                        `}
                        >
                            {
                                editable &&
                                <div className='mb-2 text-center'>
                                    <Button 
                                        className='app-button'
                                        onClick={(e) => handleRemoveFile(e,field,index,data[field][index]?.delete ? true : false)}
                                        text={data[field][index]?.delete ? t('actions.restore.button') : t('actions.delete.button')}
                                        type={data[field][index]?.delete ? 'restore' : 'delete'}
                                        variant={data[field][index]?.delete ? '' : 'contained'}
                                    />
                                </div>
                            }
                            <div className='truncate mb-2'>{linkText}</div>
                            {
                                editable ?
                                    item?.upload ? 
                                        <div className='font-bold text-red-600 text-sm truncate'>{t('file.new')}</div> 
                                    : 
                                        <div className='text-sm truncate'>{t('file.existent')}</div> 
                                :
                                    ''
                            }          
                            <div className='text-xs mb-1 truncate'>
                                {
                                    editable ?

                                        item?.upload && item.upload?.size ? 
                                            formatBytes(item.upload.size) 
                                        : 
                                            '-'
                                    :
                                        ''
                                }
                            </div>
                            <div className={`item-modal-file-div ${editable && data[field][index]?.delete && 'item-modal-link-file-div-deleted'}`}>
                                {
                                    (!config?.target || config.target === 'modal') && openUrlModal ?
                                        <a 
                                            key={'table_'+table+'_item_'+item?.rowIndex+'_field_'+field+'_file_'+index} 
                                            className={`${item.type === 'image' ? 'item-modal-link-image cursor-pointer' : 'item-modal-link-file cursor-pointer'}`} 
                                            onClick={() => 
                                                !editable || item.type === 'image' || item.type === 'pdf' ? 
                                                    openUrlModal(item?.path,true,item?.type,item?.mime,item?.name)
                                                :
                                                    null
                                            }
                                        >                                                                                        
                                            {
                                                item.type === 'image' ? 
                                                    <div className='item-modal-image-div'>
                                                        <img src={item?.path}/>
                                                    </div>
                                                :
                                                    item.type === 'pdf' ?
                                                        <div className='item-modal-file'>
                                                            <iframe
                                                                src={item?.path}                    
                                                                style={{width:'100%', height: '100%', pointerEvents: 'none'}}
                                                            ></iframe>
                                                        </div>
                                                    :
                                                        <div className='item-modal-file'><ViewIcon fontSize='large'/></div>
                                            }                                                                                        
                                        </a>
                                    :
                                        <a 
                                            key={'table_'+table+'_item_'+item?.rowIndex+'_field_'+field+'_file_'+index} 
                                            className={`${item.type === 'image' ? 'item-modal-link-image' : 'item-modal-link-file'}`} 
                                            href={item?.path} 
                                            target={config?.target}
                                        >                                                                                
                                            {
                                                item.type === 'image' ?
                                                    <div className='item-modal-image-div'>
                                                        <img src={item?.path}/>
                                                    </div>
                                                :                                                                                            
                                                    item.type === 'pdf' ?
                                                        <div className='item-modal-file'>
                                                            <iframe
                                                                src={item?.path}                    
                                                                style={{width:'100%', height: '100%', pointerEvents: 'none'}}
                                                            ></iframe>
                                                        </div>
                                                    :
                                                        <div className='item-modal-file'><ViewIcon fontSize='large'/></div>
                                            }
                                            
                                        </a>
                                }
                            </div>                                                                        
                        </div> 
                    );
                })
            }
        </div>
        </>
    );
}